export const KALSHI_TAKER_FEE_RATE = 0.07;
export const KALSHI_TAKER_FEES = {
    perContract: (price) => KALSHI_TAKER_FEE_RATE * price * (1 - price),
};
/** Fees switched off: only for before/after comparisons, never for display. */
export const NO_FEES = { perContract: () => 0 };
/** Contracts a stake buys at `price` once the entry fee is paid. */
export function contractsForStake(stake, price, fees = KALSHI_TAKER_FEES) {
    return stake / (price + fees.perContract(price));
}
/** P&L of a stake held to settlement. */
export function heldTradePnl(stake, entryPrice, won, fees = KALSHI_TAKER_FEES) {
    return won ? contractsForStake(stake, entryPrice, fees) - stake : -stake;
}
/** P&L of a stake sold before settlement at `exitPrice` (the bid). */
export function earlyExitTradePnl(stake, entryPrice, exitPrice, fees = KALSHI_TAKER_FEES) {
    const contracts = contractsForStake(stake, entryPrice, fees);
    return contracts * (exitPrice - fees.perContract(exitPrice)) - stake;
}
/** Total fees on a trade: entry fee, plus the exit fee when sold early. */
export function tradeFees(stake, entryPrice, exitPrice, fees = KALSHI_TAKER_FEES) {
    const contracts = contractsForStake(stake, entryPrice, fees);
    return (contracts * fees.perContract(entryPrice) +
        (exitPrice === null ? 0 : contracts * fees.perContract(exitPrice)));
}
//# sourceMappingURL=fees.js.map